<template>
  <div class="add-social-network">
    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"
    />

    <transition name="fade" mode="out-in">
      <div class="platform-added" v-if="platformAdded">
        <p>
          The <span class="platform-name">{{ platform }}</span
          > account, <strong>{{ platformAdded.value }}</strong> has been
          added!<br />You can change this later in the site builder, under
          <strong>Contact Details</strong>.
        </p>

        <p>
          If you've added all of your accounts, please
          <strong>continue</strong>.
        </p>
      </div>

      <SocialNetworkForm
        v-else
        v-model="socialNetwork"
        :platform="platform"
        @submit="updateSiteContact"
      />
    </transition>
  </div>
</template>

<script>
import notification from '@/mixins/notification'

import {
  createCompanySiteContactData,
  readCompanySiteContactsData
} from '@/lib/contacts'

import SocialNetworkForm from '@/components/SiteSetup/SocialNetworkForm'

export default {
  name: 'addSocialNetwork',

  data() {
    return {
      socialNetwork: {},
      socialMediaAdded: false,
      currentPlatforms: [],
      errors: {}
    }
  },

  mixins: [notification],

  props: {
    companyId: String,
    siteId: String,
    platform: String
  },

  computed: {
    platformAdded() {
      return this.currentPlatforms.find(
        (account) => account.key === this.platform
      )
    }
  },

  methods: {
    getData() {
      readCompanySiteContactsData(this.companyId, this.siteId, {
        page: 1,
        page_size: 250
      }).then(({data}) => {
        this.currentPlatforms = data
        this.$emit('currentPlatforms', data)
      })
    },

    updateSiteContact(data) {
      createCompanySiteContactData(this.companyId, this.siteId, data)
        .then(({data}) => {
          this.triggerNotification('success', 'social network', 'added')
          this.getData()
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    }
  },

  mounted() {
    this.getData()
  },

  components: {
    SocialNetworkForm
  }
}
</script>

<style lang="sass" scoped>
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.add-social-network
  max-width: 500px
  margin: $gap-large auto

.platform-name
  text-transform: capitalize

.platform-added
  text-align: center
  margin-top: $gap-large
</style>
